import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
import Loading from "../../components/Loading";
import Paginator from "../../components/Paginator";
import PollEditButton from "../../components/PollEditButton";
import PollAnswers from "../../components/PollAnswers";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import { WhisperSpinner } from "react-spinners-kit";
import poor from "../../assets/poor.svg";
import middle from "../../assets/middle.svg";
import good from "../../assets/good.svg";
import excellent from "../../assets/excellent.svg";
import poor1 from "../../assets/poor1.svg";
import middle1 from "../../assets/middle1.svg";
import good1 from "../../assets/good1.svg";
import excellent1 from "../../assets/excellent1.svg";
import CustomButton from "../../components/CustomButton";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import Plus from "../../assets/plus.svg";
import QuestionView from "../../components/QuestionView";
import { toast } from "react-toastify";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";

export default class Polls extends Component {
  constructor(props) {
    super(props);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.state = {
      Questions: [],
      columnDefs: [
        {
          headerName: "عنوان",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ اعتبار",
          field: "credit",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مدت اعتبار",
          field: "timeSpan",
          cellRenderer: "formatDay",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع سرویس",
          field: "invoiceServiceType",
          valueFormatter: this.formatServices,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "پاسخ‌ها",
          field: "answerType",
          cellRenderer: "PollAnswers",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            minWidth: "120px",
          },
          lockPosition: true,
        },
        {
          headerName: "وضعیت",
          field: "isActive",
          valueFormatter: this.formatActiveContent,
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "PollEditButton",
          cellRendererParams: { editItem: this.editItem.bind(this) },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      rowData: [],
      frameworkComponents: {
        PollEditButton: PollEditButton,
        formatCurrency: this.formatCurrency,
        formatDay: this.formatDay,
        PollAnswers: PollAnswers,
      },
      currentPage: 0,
      totalPages: 0,
      dataLoading: true,
      pageLoading: true,
      ModalShow: false,
      modalType: 0,
      NameErrorText: "",
      NameValue: "",
      CreditErrorText: "",
      CreditValue: "",
      TimeSpanErrorText: "",
      TimeSpanValue: "",
      insideCheck: false,
      packCheck: false,
      sendCheck: false,
      ModalShow2: false,
      poorState: false,
      middleState: false,
      goodState: false,
      excellentState: false,
      selectedQuestions: [],
      selectedAnswer: [],
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      currentRestaurantId: null,
      priceUnit: "",
    };

    this.tableContainer = React.createRef();

    this.GetPollManagers = this.GetPollManagers.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
    this.resetModalValues = this.resetModalValues.bind(this);
    this.getPolls = this.getPolls.bind(this);
  }

  formatDay(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={false}
          suffix={" روز"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatActiveContent(params) {
    if (params.value) return "فعال";
    else return "غیرفعال";
  }

  formatServices(params) {
    let arr = params.value.split(",");
    let text = "";
    arr.forEach((element) => {
      element = Number(element);
      if (element === 0) {
        if (text === "") text = "داخلی";
        else text += " ، داخلی";
      } else if (element === 1) {
        if (text === "") text = "بسته‌بندی";
        else text += " ، بسته‌بندی";
      } else if (element === 2) {
        if (text === "") text = "ارسال";
        else text += " ، ارسال";
      }
    });
    if (text === "") text = "هیچکدام";
    return text;
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" " + this.state.priceUnit}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  resetModalValues(id) {
    this.setState(
      {
        writingProgress: false,
        NameErrorText: "",
        NameValue: "",
        IsActive: true,
        CreditErrorText: "",
        CreditValue: "",
        TimeSpanErrorText: "",
        TimeSpanValue: "",
        insideCheck: false,
        packCheck: false,
        sendCheck: false,
        selectedQuestions: [],
        selectedAnswer: [],
        poorState: false,
        middleState: false,
        goodState: false,
        excellentState: false,
      },
      () => {
        this.state.rowData.forEach((element) => {
          if (element.id === id) {
            if (element.invoiceServiceType.indexOf("0") > -1)
              this.setState({ insideCheck: true });
            if (element.invoiceServiceType.indexOf("1") > -1)
              this.setState({ packCheck: true });
            if (element.invoiceServiceType.indexOf("2") > -1)
              this.setState({ sendCheck: true });

            if (element.answerType.indexOf("1") > -1)
              this.setState({ poorState: true });
            if (element.answerType.indexOf("2") > -1)
              this.setState({ middleState: true });
            if (element.answerType.indexOf("3") > -1)
              this.setState({ goodState: true });
            if (element.answerType.indexOf("4") > -1)
              this.setState({ excellentState: true });

            this.setState({
              selectedAnswer: element.answerType,
              NameValue: element.name,
              IsActive: element.isActive,
              TimeSpanValue: element.timeSpan,
              CreditValue: element.credit,
              selectedQuestions: element.pollIds,
            });
          }
        });
      }
    );
  }

  editItem(e) {
    this.resetModalValues(e);
    let currentItem = null;
    this.state.rowData.forEach((element) => {
      if (element.id === e) currentItem = element;
    });
    this.setState({ ModalShow: true, modalType: e, currentItem: currentItem });
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              currentRestaurantId: result.result[0].id,
              priceUnit: result.result[0].rtlPriceTitle,
            },
            () => {
              this.getPolls();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.getBusinessInfo();
  }

  getPolls() {
    if (Authorization().token) {
      this.setState({ pageLoading: true });

      let data = isUser
        ? {
            businessCode: this.props.match.params.id,
          }
        : {};
      data = Object.assign(data, ClubAuthorization());
      let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

      fetch("https://94.101.187.196/api/Poll/GetPolls", {
        method: "GET",
        headers: { Authorization: jsonString },
      })
        .then((res) => {
          console.log(res);
          if (res.status === 401) {
            LogoutFunction();
          } else {
            return res.json();
          }
        })
        .then((result) => {
          console.log("GetPolls: ", result);
          this.setState(
            { Questions: result.results, pageLoading: false },
            () => {
              this.GetPollManagers(1);
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      LogoutFunction();
    }
  }

  GetPollManagers(page) {
    if (Authorization().token) {
      this.setState({ dataLoading: true });

      let data = isUser
        ? {
            businessCode: this.props.match.params.id,
          }
        : {};
      data = Object.assign(data, ClubAuthorization());
      let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

      fetch(
        "https://94.101.187.196/api/Poll/GetPollManagers?restaurantId=" +
          this.state.currentRestaurantId +
          "&page=" +
          page,
        {
          method: "GET",
          headers: { Authorization: jsonString },
        }
      )
        .then((res) => {
          console.log(res);
          if (res.status === 401) {
            LogoutFunction();
          } else {
            return res.json();
          }
        })
        .then((result) => {
          console.log("GetPollManagers: ", result);

          this.setState({
            dataLoading: false,
            rowData: result.results[0].items,
            currentPage: result.results[0].currentPage,
            totalPages: result.results[0].totalPages,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      LogoutFunction();
    }
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onBack() {
    this.props.history.push(
      "/Restaurants/" + this.props.match.params.id + "/Club"
    );
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstPageClick() {
    this.GetPollManagers(1);
  }

  onPreviousPageClick() {
    this.GetPollManagers(this.state.currentPage - 1);
  }

  onNextPageClick() {
    this.GetPollManagers(this.state.currentPage + 1);
  }

  onLastPageClick() {
    this.GetPollManagers(this.state.totalPages);
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  onChooseQuestionsClick() {
    this.setState({ ModalShow2: true });
  }

  onConfirm() {
    if (!this.state.NameValue) {
      this.setState(
        { NameErrorText: "عنوان نظرسنجی نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.NameErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ NameErrorText: "" });
    }

    if (!this.state.CreditValue) {
      this.setState(
        { CreditErrorText: "مبلغ اعتبار نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.CreditErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ CreditErrorText: "" });
    }

    if (!this.state.TimeSpanValue) {
      this.setState(
        { TimeSpanErrorText: "مدت اعتبار نمی‌تواند خالی باشد" },
        () => {
          toast.error(this.state.TimeSpanErrorText, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
      );
      return;
    } else {
      this.setState({ TimeSpanErrorText: "" });
    }

    let services = "";
    if (this.state.insideCheck) {
      if (services === "") services = "0";
      else services += ",0";
    }
    if (this.state.packCheck) {
      if (services === "") services = "1";
      else services += ",1";
    }
    if (this.state.sendCheck) {
      if (services === "") services = "2";
      else services += ",2";
    }

    if (!services) {
      toast.error(
        "حداقل یکی از سرویس‌های داخلی، بسته‌بندی یا ارسال باید انتخاب شود",
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        }
      );
      return;
    }

    let answer = "";
    if (this.state.poorState) {
      if (answer === "") answer = "1";
      else answer += ",1";
    }
    if (this.state.middleState) {
      if (answer === "") answer = "2";
      else answer += ",2";
    }
    if (this.state.goodState) {
      if (answer === "") answer = "3";
      else answer += ",3";
    }
    if (this.state.excellentState) {
      if (answer === "") answer = "4";
      else answer += ",4";
    }

    if (answer.length < 3) {
      toast.error("حداقل 2 گزینه برای پاسخ به سوالات باید انتخاب شود", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    if (this.state.selectedQuestions < 1) {
      toast.error("حداقل یک سوال از لیست سوالات باید انتخاب شود", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      return;
    }

    let data = [
      {
        restaurantId: Number(this.state.currentRestaurantId),
        id: this.state.modalType,
        name: this.state.NameValue,
        timeSpan: this.state.TimeSpanValue,
        credit: Number(this.state.CreditValue),
        isActive: this.state.IsActive,
        invoiceServiceType: services,
        answerType: answer,
        pollIds: this.state.selectedQuestions,
      },
    ];

    let data1 = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data1 = Object.assign(data1, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data1));

    this.setState({ writingProgress: true });
    fetch("https://94.101.187.196/api/Poll/AddOrUpdatePollManagers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          toast.success(
            this.state.modalType === 0
              ? "نظرسنجی با موفقیت اضافه شد"
              : "نظرسنجی مورد نظر با موفقیت ویرایش شد",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            }
          );
          this.setState({ writingProgress: false, ModalShow: false }, () => {
            this.GetPollManagers(this.state.currentPage);
          });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });
  }

  onAddNewButton() {
    this.resetModalValues(0);
    this.setState({ ModalShow: true, modalType: 0 });
  }

  onPoorClick() {
    this.setState({ poorState: !this.state.poorState });
  }

  onMiddleClick() {
    this.setState({ middleState: !this.state.middleState });
  }

  onGoodClick() {
    this.setState({ goodState: !this.state.goodState });
  }

  onExcellentClick() {
    this.setState({ excellentState: !this.state.excellentState });
  }

  onConfirmQuestions(list) {
    console.log(list);
    this.setState({ selectedQuestions: list, ModalShow2: false });
  }

  render() {
    if (!this.state.pageLoading)
      return (
        <div className="Login">
          <div className="header">
            <div
              onClick={this.onBack.bind(this)}
              className="linkStyle backButton"
            >
              <img
                src={Back}
                alt=""
                className="backButtonIcon"
                style={{ transform: "rotate(180deg)" }}
              />
              بازگشت
            </div>
            <Tooltip title="خروج">
              <div
                onClick={this.onLogout.bind(this)}
                className="linkStyle backButton"
              >
                <img src={Logout} alt="" className="backButtonIcon" />
              </div>
            </Tooltip>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">نظرسنجی</div>
            <div className="RestaurantsListSubTitle">
              طراحی و ویرایش سوالات و جزییات نظرسنجی
            </div>
          </div>

          <div className="pageContents" ref={this.tableContainer}>
            {!this.state.dataLoading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <CustomButton
                  title="نظرسنجی جدید"
                  imgHeight={20}
                  imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  img={Plus}
                  onClick={this.onAddNewButton.bind(this)}
                />
              </div>
            )}
            {!this.state.dataLoading && (
              <div className="tableContainer ag-theme-alpine">
                <AgGridReact
                  enableRtl={true}
                  autoHeight={true}
                  animateRows={true}
                  enableBrowserTooltips={true}
                  tooltipMouseTrack={true}
                  suppressSizeToFit={false}
                  columnDefs={this.state.columnDefs}
                  localeText={this.state.gridLocaleText}
                  rowData={this.state.rowData}
                  suppressDragLeaveHidesColumns={true}
                  suppressMovable={true}
                  skipHeaderOnAutoSize={false}
                  // onGridReady={this.onGridReady.bind(this)}
                  onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                  rowHeight={window.innerWidth <= 587 ? 40 : 50}
                  headerHeight={window.innerWidth <= 587 ? 40 : 50}
                  frameworkComponents={this.state.frameworkComponents}
                  // onRowClicked={this.onGridRowClicked.bind(this)}
                  // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                  enableCellTextSelection={true}
                  ensureDomOrder={true}
                ></AgGridReact>
              </div>
            )}
            {!this.state.dataLoading && (
              <div
                style={{
                  width: "100%",
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Paginator
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onFirstPageClick={this.onFirstPageClick.bind(this)}
                  onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                  onNextPageClick={this.onNextPageClick.bind(this)}
                  onLastPageClick={this.onLastPageClick.bind(this)}
                />
              </div>
            )}

            {this.state.dataLoading && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <WhisperSpinner
                  size={50}
                  color="var(--brown1)"
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                  loading={true}
                />
              </div>
            )}
          </div>

          <Modal
            show={this.state.ModalShow}
            size="md"
            animation={true}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <div className="settingContainer" style={{ padding: "10px" }}>
              <div className="ModalTitleSM">
                {this.state.modalType === 0 ? "نظرسنجی جدید" : "ویرایش نظرسنجی"}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  marginTop: "20px",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <div
                  className="settingItemContainer"
                  style={{ justifyContent: "flex-start" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flex: "1",
                      marginLeft: "10px",
                      alignItems: "center",
                    }}
                  >
                    <div className="settingLabel">عنوان</div>
                    <Form.Control
                      maxLength="50"
                      className={
                        this.state.NameErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      placeholder="عنوان نظرسنجی"
                      type="text"
                      name="NameValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.NameValue}
                    />
                  </div>
                  <BootstrapSwitchButton
                    checked={this.state.IsActive}
                    onChange={(checked) => {
                      this.setState({ IsActive: checked });
                    }}
                    onlabel="فعال"
                    offlabel="غیرفعال"
                    onstyle="primary"
                    offstyle="warning"
                    width={75}
                  />
                </div>

                <div className="settingItemContainer">
                  <div
                    className="settingLabel"
                    style={{ whiteSpace: "noWrap" }}
                  >
                    مبلغ اعتبار
                  </div>
                  <NumericFormat
                    className={
                      this.state.CreditErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter form-control"
                        : "form-control inputStyleForm textAlignCenter"
                    }
                    // placeholder="مبلغ"
                    placeholder={this.state.priceUnit}
                    style={{ direction: "ltr", maxWidth: "120px" }}
                    type="text"
                    name="CreditValue"
                    value={this.state.CreditValue}
                    allowNegative={true}
                    displayType={"input"}
                    thousandSeparator={true}
                    isNumericString
                    onValueChange={(values) => {
                      this.setState({ CreditValue: values.value });
                    }}
                  />
                </div>

                <div className="settingItemContainer">
                  <div
                    className="settingLabel"
                    style={{ whiteSpace: "noWrap" }}
                  >
                    مدت اعتبار
                  </div>
                  <Form.Control
                    maxLength="3"
                    className={
                      this.state.TimeSpanErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    style={{ maxWidth: "70px", direction: "ltr" }}
                    placeholder="روز"
                    type="text"
                    name="TimeSpanValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.TimeSpanValue}
                  />
                </div>

                <div
                  className="settingItemContainer"
                  style={{ fontSize: "14px", fontFamily: "SFUIDisplayBold" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onPoorClick.bind(this)}
                  >
                    <img
                      src={this.state.poorState ? poor : poor1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      ضعیف
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onMiddleClick.bind(this)}
                  >
                    <img
                      src={this.state.middleState ? middle : middle1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      متوسط
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onGoodClick.bind(this)}
                  >
                    <img
                      src={this.state.goodState ? good : good1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      خوب
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onExcellentClick.bind(this)}
                  >
                    <img
                      src={this.state.excellentState ? excellent : excellent1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      عالی
                    </div>
                  </div>
                </div>

                <div
                  className="settingItemContainer"
                  style={{
                    fontSize: "14px",
                    fontFamily: "SFUIDisplayBold",
                    direction: "ltr",
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    label="داخلی"
                    checked={this.state.insideCheck}
                    onChange={() =>
                      this.setState({ insideCheck: !this.state.insideCheck })
                    }
                  />
                  <Form.Check
                    type="checkbox"
                    label="بسته بندی"
                    checked={this.state.packCheck}
                    onChange={() =>
                      this.setState({ packCheck: !this.state.packCheck })
                    }
                  />
                  <Form.Check
                    type="checkbox"
                    label="ارسال"
                    checked={this.state.sendCheck}
                    onChange={() =>
                      this.setState({ sendCheck: !this.state.sendCheck })
                    }
                  />
                </div>

                <div className="settingItemContainer">
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="انتخاب سوالات"
                      minHeight="35px"
                      onClick={this.onChooseQuestionsClick.bind(this)}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="ذخیره"
                    loading={this.state.writingProgress}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.onConfirm.bind(this)}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Modal>

          <Modal
            show={this.state.ModalShow2}
            animation={true}
            size="md"
            backdrop="static"
            backdropClassName="backdropClassName"
            onHide={this.hideModal2.bind(this)}
            centered
          >
            {this.state.ModalShow2 && (
              <QuestionView
                currentSelected={this.state.selectedQuestions}
                list={this.state.Questions}
                onConfirmQuestions={this.onConfirmQuestions.bind(this)}
                hideModal={this.hideModal2.bind(this)}
              />
            )}
          </Modal>
          {/* <ReactTooltip effect="solid" /> */}
        </div>
      );
    else return <Loading />;
  }
}
